'use client';

import { Transition as HeadlessTransition } from '@headlessui/react';

type Props = React.ComponentProps<typeof HeadlessTransition>;

export const Transition = (props: Props) => <HeadlessTransition {...(props as object)} />;
